<template lang="pug">
v-flex
  v-icon(small).pr-1 person
  | {{ data }}
</template>

<script>
export default {
  computed: {},
  props: {
    data: {
      type: Number,
    },
  },
};
</script>
